import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './LegalPage.css';


const Disclaimer = () => {
  return (
    <>
      <Header />
      <div className="legal-page">
        <div className="legal-container">
          <Link to="/" className="back-link">← Back to Home</Link>
          
          <h1 className="legal-title">Disclaimer</h1>
          <p className="legal-date">Last Updated: January 27, 2026</p>
          
          <div className="legal-content">
            <p className="legal-intro">
              The information and services provided by VIDYADHAR GLOBAL AI INNOVATIONS PRIVATE LIMITED (operating as WhiteLabelDevs) are for professional software development purposes only.
            </p>
            
            <section className="legal-section">
              <h2>1. Technology Trademarks & Fair Use</h2>
              <p><strong>All product names, logos, frameworks, and technology brands displayed on this website are the property of their respective owners.</strong></p>
              <p>WhiteLabelDevs is not affiliated, associated, authorized, endorsed by, or in any way officially connected with:</p>
              <ul>
                <li>Laravel (trademark of Taylor Otwell)</li>
                <li>React.js (trademark of Meta Platforms, Inc.)</li>
                <li>Next.js (trademark of Vercel Inc.)</li>
                <li>PHP (PHP Group)</li>
                <li>MongoDB, MySQL, PostgreSQL, Redis</li>
                <li>A2z Cloud or any other hosting providers</li>
                <li>Any other frameworks, libraries, or technologies mentioned</li>
              </ul>
              <p>These technology names and brands are referenced strictly for <strong>descriptive and service delivery purposes</strong> under fair usage policy. We are an independent service provider offering development and hosting services using these technologies.</p>
            </section>
            
            <section className="legal-section">
              <h2>2. No Guarantees</h2>
              <p>We do not guarantee:</p>
              <ul>
                <li>Specific business profits or revenue outcomes</li>
                <li>Search engine rankings or SEO results</li>
                <li>Sales, revenue, or user growth targets</li>
                <li>Specific uptime percentages beyond our SLA commitments</li>
                <li>Third-party service availability or performance</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>3. White-Label Services</h2>
              <p>White-label services are provided as development and technical support only. The client is fully responsible for:</p>
              <ul>
                <li>Their own branding, marketing, and business operations</li>
                <li>Client commitments and service level agreements with end users</li>
                <li>Legal compliance of deployed software in their jurisdiction</li>
                <li>Hosting, data handling, privacy compliance, and regulatory requirements</li>
                <li>Content, data, and user-generated content on their platforms</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>4. Cloud & Hosting Services</h2>
              <p>Our cloud and hosting services are provided in partnership with third-party infrastructure providers. We are not responsible for:</p>
              <ul>
                <li>Infrastructure provider outages or maintenance</li>
                <li>Network connectivity issues beyond our control</li>
                <li>Data center incidents or force majeure events</li>
                <li>Client's own application code performance issues</li>
                <li>Security vulnerabilities in client's application code</li>
              </ul>
              <p>While we provide managed hosting services including security monitoring, backups, and performance optimization, ultimate data security and compliance responsibility rests with the client.</p>
            </section>
            
            <section className="legal-section">
              <h2>5. SEO & Growth Services</h2>
              <p>SEO services are advisory and implementation-based. Results depend on multiple factors including:</p>
              <ul>
                <li>Search engine algorithm changes</li>
                <li>Market competition and industry dynamics</li>
                <li>Content quality and website structure</li>
                <li>Client's ongoing content and marketing efforts</li>
              </ul>
              <p>We provide technical SEO implementation and recommendations but cannot guarantee specific ranking positions or traffic increases.</p>
            </section>
            
            <section className="legal-section">
              <h2>6. Limitation of Liability</h2>
              <p>We are not responsible for:</p>
              <ul>
                <li>Client business decisions or strategic choices</li>
                <li>Legal compliance of deployed software or hosted applications</li>
                <li>Third-party integrations, APIs, and service outages</li>
                <li>Data loss due to client actions or third-party service failures</li>
                <li>Revenue loss, business interruption, or consequential damages</li>
                <li>Security breaches resulting from client's own code vulnerabilities</li>
              </ul>
              <p>Our maximum liability is limited to the amount paid for the specific service in question.</p>
            </section>
            
            <section className="legal-section">
              <h2>7. Service Scope & Expectations</h2>
              <p>All services are provided on a best-effort basis within agreed scope. Clients should:</p>
              <ul>
                <li>Maintain realistic expectations about project timelines and outcomes</li>
                <li>Understand that software development involves iteration and refinement</li>
                <li>Provide timely feedback and necessary access for service delivery</li>
                <li>Have their own backup and disaster recovery plans</li>
                <li>Maintain appropriate insurance for their business operations</li>
              </ul>
            </section>
            
            <section className="legal-section">
              <h2>8. Changes to This Disclaimer</h2>
              <p>We reserve the right to update this disclaimer at any time. Continued use of our services constitutes acceptance of the updated disclaimer.</p>
            </section>
          </div>
          
          <div className="legal-footer">
            <p><strong>VIDYADHAR GLOBAL AI INNOVATIONS PRIVATE LIMITED</strong></p>
            <p>Operating as: WhiteLabelDevs</p>
            <p>CIN: U62090UP2026PTC241378</p>
            <p>2 Maa Pitambara Complex, Dwarika Green Phase 2, Agra Bamroli Road, UP 282009</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Disclaimer;